<template>
  <div class="yu-article">
    <slot/>
  </div>
</template>

<script>


export default {
  name: 'YuArticle',
};
</script>
<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .yu-article {
    font-size: $big;
    vertical-align: top;
    box-sizing: border-box;
    display: inline-block;
    width: 75%;
    min-height: 600px;
    background: #fff;
    border: 1px solid $border;
    padding: 0 50px 30px 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/yu-article.vue